import { LoadingSpinner, FigmaTypography } from "@libs/zapi-ui/custom";
import { InitialHeader } from "./_InitialHeader";

export function LoadingWidget() {
  return (
    <div className="h-full flex flex-col flex-grow overflow-y-auto" data-testid="claims-root">
      <InitialHeader />
      <div className="h-full flex flex-col p-2 gap-2 items-center justify-center bg-innoveraZinc-100 rounded-b-[8px]">
        <LoadingSpinner />
        <FigmaTypography variant="body-3" color="zinc500" className="text-center font-light">
          Loading claims...
        </FigmaTypography>
      </div>
    </div>
  );
}
